import * as React from 'react';
import { useContext } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { OrderCardContext } from '../OrderCard';
import { BaseButton } from '../../../BaseComponents';
import Money from '../../../Money';
import CommonItem from '../CommonItem/CommonItem';
import { OrderStatus } from '@websky/graphql';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import { CdnIcon } from '@shared/ui';

export interface Props {
	className?: string;
	onDownloadTicket?: () => void;
	hidePrice?: boolean;
}

const OrderBooking: React.FC<Props> = ({ className, onDownloadTicket, hidePrice }) => {
	const { OrderBooking: css } = useTheme('OrderCard');
	const { t } = useTranslation('OrderCard');
	const { order, type } = useContext(OrderCardContext);

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	const onDownloadTicketHandler: React.MouseEventHandler = e => {
		e.preventDefault();

		onDownloadTicket();
	};

	return (
		<CommonItem
			icon={'Document/Ticket'}
			type={type}
			iconClassName={css.icon}
			className={cn(css.root, className, {
				[css.type_review]: type === 'review',
				[css.type_account]: type === 'account'
			})}
			text={
				<>
					{type === 'account' && (
						<>
							<span className={css.orderCode}>
								{t('Booking ID')}:{' '}
								<span className={css.value}>{order.locator ? order.locator : order.id}</span>
							</span>
						</>
					)}

					{type === 'review' && (
						<>
							<span className={css.orderCode}>
								{t('Booking ID')}:{' '}
								<span className={css.value}>{order.locator ? order.locator : order.id}</span>
							</span>

							{!hidePrice && (
								<span className={css.price}>
									{t('Total')}: <Money money={order.price?.total} />
								</span>
							)}
						</>
					)}
				</>
			}
			buttons={
				type === 'review'
					? order.status === OrderStatus.Confirmed && (
							<div className={css.download_wrapper}>
								<BaseButton
									variant="optionEdit"
									className={css.download}
									onClick={onDownloadTicketHandler}
								>
									{t('Download')}
									<CdnIcon icon={'Action/Download'} />
								</BaseButton>
							</div>
					  )
					: !isMobile &&
					  !hidePrice && (
							<>
								{t('Total')}:<Money money={order.price?.total} />
							</>
					  )
			}
		/>
	);
};

export default OrderBooking;
